import { usePathname } from 'next/navigation'

export type PageType = 
  | 'home'
  | 'country' 
  | 'region'
  | 'state'
  | 'city'
  | 'category'
  | 'product'
  | 'legal'
  | 'other'

export interface PageInfo {
  type: PageType
  slug?: string
  citySlug?: string
  categorySlug?: string
  productSlug?: string
  countrySlug?: string
  regionSlug?: string
  stateSlug?: string
}

export function usePageType(): PageInfo {
  const pathname = usePathname()
  const pathSegments = pathname.split('/').filter(Boolean)

  // Home page
  if (pathname === '/' || pathname === '') {
    return { type: 'home' }
  }

  // Legal pages (imprint, privacy, terms, etc.)
  if (pathSegments.length === 1 && !['l', 'r', 's', 'c'].includes(pathSegments[0])) {
    return { 
      type: 'legal',
      slug: pathSegments[0]
    }
  }

  // Country pages: /l/[country]
  if (pathSegments.length === 2 && pathSegments[0] === 'l') {
    return {
      type: 'country',
      countrySlug: pathSegments[1]
    }
  }

  // Region pages: /r/[region]
  if (pathSegments.length === 2 && pathSegments[0] === 'r') {
    return {
      type: 'region',
      regionSlug: pathSegments[1]
    }
  }

  // State pages: /s/[state]
  if (pathSegments.length === 2 && pathSegments[0] === 's') {
    return {
      type: 'state',
      stateSlug: pathSegments[1]
    }
  }

  // City pages: /c/[city]
  if (pathSegments.length === 2 && pathSegments[0] === 'c') {
    return {
      type: 'city',
      citySlug: pathSegments[1]
    }
  }

  // Category pages: /c/[city]/c/[category]
  if (pathSegments.length === 4 && pathSegments[0] === 'c' && pathSegments[2] === 'c') {
    return {
      type: 'category',
      citySlug: pathSegments[1],
      categorySlug: pathSegments[3]
    }
  }

  // Product/Activity pages: /c/[city]/a/[product]
  if (pathSegments.length === 4 && pathSegments[0] === 'c' && pathSegments[2] === 'a') {
    return {
      type: 'product',
      citySlug: pathSegments[1],
      productSlug: pathSegments[3]
    }
  }

  // Fallback for unknown routes
  return { type: 'other' }
} 